import { render, staticRenderFns } from "./Monitoring4.vue?vue&type=template&id=70943070"
import script from "./Monitoring4.vue?vue&type=script&lang=js"
export * from "./Monitoring4.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports